import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery';
import DropDownCellAllProdutoGridsEngarrafado from "./myDropDownCellAllProdutoGridsEngarrafado";
import DropDownCellAllProdutoGridsGranel from './myDropDownCellAllProdutoGridsGranel';
import DropDownCellAllProdutoGridsVendas from './myDropDownCellAllProdutoGridsVendas';
import DropDownCellTipoSelo from './myDropDownCellTipoSelo';

class DropDownCellAllEntidadesInstVinicaVendas extends Component {
  state = {
    optionsProdutos: [],
    optionsProdutosFilter: [],
    selectedValue: null, // Armazena o valor selecionado
  };

  handleChange = e => {
    const selectedValue = e.target.value;
    this.setState({ selectedValue });
    
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: selectedValue
    });

    if (this.props.tipoProduto) {
        DropDownCellAllProdutoGridsVendas.GetAllProdutos("Vendas", selectedValue.value);
    } else {
      DropDownCellTipoSelo.GetEntidadeSerie(selectedValue.value);
    }
  };

  GetAllProdutos(tipoProduto) {
    var ProdutoString = {};

    (async () => {
      if ($('#instal_vinica_auto').val() !== '' && $('#instal_vinica_auto').val() !== null) {
        const data = { idInstVinica: $('#instal_vinica_auto').val().split('!')[0] };
        const ProdutoList = await services.apiCall.requestApi(
          "/Fiscalizacao/GetEntidadesByInstacaoVinica",
          data,
          "get"
        );

        if (ProdutoList) {
          const optionsProdutos = ProdutoList.map((Produto) => ({
            text: Produto.nif + " - " + Produto.nome,
            value: Produto.codEntidade
          }));

          const selectedValue = parseInt($("#instal_vinica_auto :selected").val().split("!")[1]); // Seleciona o primeiro item como padrão

          this.setState({ 
            optionsProdutos: optionsProdutos,
            optionsProdutosFilter: optionsProdutos,
            selectedValue: selectedValue
          });
        }
      }
    })();
  }

  componentDidMount = () => {
    this.GetAllProdutos("Vendas");
  };

  filterData = (filter) => {
    const filterArray = filter.value.split(" ");
    const FilterOptions = this.state.optionsProdutos.filter(option =>
      filterArray.every(val => option.text.toUpperCase().includes(val.toUpperCase()))
    );
    
    this.setState({ optionsProdutosFilter: FilterOptions });
  };

  filterChange = (event) => {
    this.filterData(event.filter);

    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field
    });
  };

  render() {
    const { dataItem, field = '' } = this.props;
    const dataValue = dataItem[field] === null ? '' : dataItem[field];
    const { optionsProdutosFilter, selectedValue } = this.state;
    if(dataValue == undefined && selectedValue){
      dataItem[field] = optionsProdutosFilter.find(c => c.value === (dataValue && dataValue.value ? dataValue.value : selectedValue))
    }
    return (
      <td>
        {dataItem.inEdit ? (
          <DropDownList
          filterable={true}
          onFilterChange={this.filterChange}
          popupSettings={{ width: 'max-content' }}
          onChange={this.handleChange}
          value={optionsProdutosFilter.find(c => c.value === (dataValue && dataValue.value ? dataValue.value : selectedValue))} // Ajuste aqui
          data={optionsProdutosFilter}
          textField="text"
          id='EntInstClass'
        />
        ) : (
          dataValue != null ? dataValue.text != undefined ? dataValue.text.toString() : optionsProdutosFilter.length > 0 ? optionsProdutosFilter.find(c => c.value === (selectedValue)).text : undefined: undefined
        )}
      </td>
    );
  }
}

export default DropDownCellAllEntidadesInstVinicaVendas;